module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"gl-security__acl-builder\">\n    <div name=\"rule-trees\">\n        <!--<div name=\"read\">\n            <div class=\"builder\"></div>\n        </div>\n        <div name=\"write\">\n            <div class=\"builder\"></div>\n        </div>\n        <div name=\"remove\">\n            <div class=\"builder\"></div>\n        </div>-->\n    </div>\n</div>")
  }
  return __output.join("");

}